import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { LocaleInfoIdSchema } from '../locale/locale.types.js';
import { metricCanonicalNames, metricValueTypes } from './metric.constants.js';
// ===== ID SCHEMAS =====
const MetricIdSchema = createIdSchema('metric');
const MetricTableSelectSchema = createStrictSchema()({
    id: MetricIdSchema,
    canonicalName: z.enum(metricCanonicalNames),
    valueType: z.enum(metricValueTypes),
    displayOrder: z.number().int(),
    targetColumn: z.string(),
    actualColumn: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
const MetricTranslationTableSelectSchema = createStrictSchema()({
    metricId: MetricIdSchema,
    localeId: LocaleInfoIdSchema,
    nameTranslation: z.string(),
    nameAbbreviationTranslation: z.string().nullable(),
    unitTranslation: z.string(),
    unitAbbreviationTranslation: z.string().nullable(),
    descriptionTranslation: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== POPULATED SCHEMAS =====
const PopulatedMetricTableSelectSchema = MetricTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    name: z.string(),
    nameAbbreviation: z.string().nullable(),
    unit: z.string(),
    unitAbbreviation: z.string().nullable(),
    description: z.string().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
// Explicitly define the schema to avoid complex type inference issues across package boundaries
const MetricInfoSchema = PopulatedMetricTableSelectSchema.extend({
    updatedAt: z.string(),
});
const MetricInfoIdSchema = MetricIdSchema;
export { MetricInfoIdSchema, MetricInfoSchema, MetricTableSelectSchema, MetricTranslationTableSelectSchema, PopulatedMetricTableSelectSchema, };
//# sourceMappingURL=metric.types.js.map